module.exports = "<lfwms-view-my-print-jobs-search></lfwms-view-my-print-jobs-search>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/view-my-print-jobs/view-my-print-jobs-home.component.html
// module id = ../../../../../src/app/features/reports/view-my-print-jobs/view-my-print-jobs-home.component.html
// module chunks = main